var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95082 26.9091V4.18182H5.91803V26.9091C5.91803 28.7273 7.88525 29.4848 8.86885 29.6364V31H1V29.6364C3.36066 29.6364 3.95082 27.8182 3.95082 26.9091Z",
    fill: "#F7722D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7705 1H1V2.81818H14.7705C16.2459 2.81818 20.6721 3.27273 20.6721 9.63636C20.6721 14.7273 16.7377 16.303 14.7705 16.4545H10.3443L7.88525 12.8182V18.2727H14.7705C17.3934 18.1212 22.6393 16.1818 22.6393 9.63636C22.6393 3.09091 17.3934 1.15152 14.7705 1Z",
    fill: "#F7722D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3443 20.0909H12.8033L17.7213 29.1818C19.6885 24.9394 24.0164 15.7273 25.5902 12.8182C27.1639 9.90909 25.5902 9.18182 24.6066 9.18182V7.81818H31V9.63636C29.4262 9.63636 28.3771 11.1515 28.0492 11.9091L18.7049 31H16.7377L10.3443 20.0909Z",
    fill: "#F7722D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95082 26.9091V4.18182H5.91803V26.9091C5.91803 28.7273 7.88525 29.4848 8.86885 29.6364V31H1V29.6364C3.36066 29.6364 3.95082 27.8182 3.95082 26.9091Z",
    stroke: "#F7722D",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7705 1H1V2.81818H14.7705C16.2459 2.81818 20.6721 3.27273 20.6721 9.63636C20.6721 14.7273 16.7377 16.303 14.7705 16.4545H10.3443L7.88525 12.8182V18.2727H14.7705C17.3934 18.1212 22.6393 16.1818 22.6393 9.63636C22.6393 3.09091 17.3934 1.15152 14.7705 1Z",
    stroke: "#F7722D",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3443 20.0909H12.8033L17.7213 29.1818C19.6885 24.9394 24.0164 15.7273 25.5902 12.8182C27.1639 9.90909 25.5902 9.18182 24.6066 9.18182V7.81818H31V9.63636C29.4262 9.63636 28.3771 11.1515 28.0492 11.9091L18.7049 31H16.7377L10.3443 20.0909Z",
    stroke: "#F7722D",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector 1.40c9d2fdca880a0eba193416d5186b93.svg";
export { ForwardRef as ReactComponent };